import * as React from "react";
import linkedin_logo from "../../../images/linkedin.png";


export class LinkedinConnectButton extends React.Component {

    render() {
        return <button className="btn linkedin" onClick={this.props.onClick}>{this.renderLinkedinLogo()}Conectar a LinkedIn Ads</button>
    }

    getImage() {
        return linkedin_logo;
    }

    renderLinkedinLogo() {
        return <img alt="LinkedIn Ads" src={this.getImage()} height={30} width={30} hspace={10} vspace={10}/>
    }
}
